import { Link } from "@tanstack/react-router";
import { SectionMark } from "@/components/section-mark";
import { cta, type OfferType } from "@/lib/analytics";

const paths = [
  {
    to: "/wystapienia" as const,
    ctaName: "sciezka-wystapienia",
    offer: "prelekcja" as OfferType,
    title: "Wystąpienia",
    desc: "Prelekcje, keynote'y, panele eksperckie, wydarzenia firmowe i spotkania dla zarządów.",
    cta: "Zobacz wystąpienia",
    primary: true,
  },
  {
    to: "/mastermind" as const,
    ctaName: "sciezka-mastermind",
    offer: "mastermind" as OfferType,
    title: "Mastermind",
    desc: "Kameralna grupa dla właścicieli firm, członków zarządów i liderów.",
    cta: "Poznaj Mastermind",
    primary: false,
  },
  {
    to: "/konsultacje" as const,
    ctaName: "sciezka-konsultacje",
    offer: "konsultacja" as OfferType,
    title: "Konsultacje indywidualne",
    desc: "Indywidualna, poufna praca nad konkretną sytuacją.",
    cta: "Poznaj konsultacje",
    primary: false,
  },
];

export function PathsSection() {
  return (
    <section
      aria-labelledby="sciezki-heading"
      className="grain relative overflow-hidden border-b border-ink/10 bg-ink"
    >
      <div aria-hidden="true" className="glow-coral -right-16 -top-16 h-64 w-64" />
      <div className="container-page relative py-12 md:py-16">
        <div id="sciezki-heading">
          <SectionMark number="02" label="Wybierz swoją ścieżkę" tone="dark" />
        </div>
        <div className="mt-8 grid items-stretch gap-4 md:grid-cols-2">
          {paths.map((item) => {
            const className = `card-soft-hover group flex h-full min-h-11 flex-col rounded-sm border p-6 text-left backdrop-blur-sm transition-colors md:p-7 ${
                item.primary
                  ? "border-coral-light/40 bg-mist/[0.09] hover:border-coral-light/60 hover:bg-mist/[0.13] md:col-span-2"
                  : "border-mist/15 bg-mist/[0.04] hover:border-coral-light/40 hover:bg-mist/[0.08]"
              }`;

            return (
              <Link
                key={item.to}
                to={item.to}
                {...cta(item.ctaName, "sciezki", item.offer, item.to)}
                data-cta-text={item.cta}
                className={className}
              >
                <h3
                  className={`serif-display text-mist ${
                    item.primary
                      ? "text-[1.7rem] md:text-[2.3rem]"
                      : "text-[1.35rem] md:text-[1.55rem]"
                  }`}
                >
                  {item.title}
                </h3>
                <p
                  className={`mt-4 flex-1 leading-relaxed text-mist/70 ${
                    item.primary ? "max-w-2xl text-lg md:text-xl" : "text-base"
                  }`}
                >
                  {item.desc}
                </p>
                <span className="mt-6 text-xs uppercase tracking-[0.16em] text-coral-light">
                  {item.cta} →
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
